import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/layout/index'
import PersonalCenterLayout from '@/layout/personalCenter'

const original = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return original.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'home',
    component: Layout,
    redirect: 'index',
    children: [
      {
        path: 'index',
        component: (resolve) => require(['@/views/Home'], resolve)
      }
    ]
  },
  {
    path: '/login',
    component: Layout,
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/login'], resolve)

      }
    ]
  },
  {
    path: '/forgetPassword',
    component: Layout,
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/ForgetPassword'], resolve)
      }
    ]
  },
  {
    path: '/showModule',
    component: Layout,
    children: [
      {
        path: '/',
        component: (resolve) => require(['@/views/ShowModule'], resolve)
      }
    ]
  },
  {
    path: '/personalCenter',
    component: Layout,
    children: [
      {
        path: 'personalCenter', // 会员中心
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/PersonalCenter/PersonalCenter'], resolve)
          }
        ]
      },
      {
        path: 'myaddon', // 我购买的插件
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/PersonalCenter/MyAddon'], resolve)
          }
        ]
      },
      {
        path: 'profile', // 账户设置
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/PersonalCenter/Profile'], resolve)
          }
        ]
      },
      {
        path: 'recharge', // 充值余额
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/PersonalCenter/Recharge'], resolve)
          }
        ]
      },
      {
        path: 'editPassword', // 修改密码
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/PersonalCenter/EditPassword'], resolve)
          }
        ]
      },
      {
        path: 'developerApply', // 开发者认证
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/DevApply'], resolve)
          }
        ]
      },
      {
        path: 'developerMyPlugins', // 我上传的插件
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/MyPlugins'], resolve)
          }
        ]
      },
      {
        path: 'developerPluginForm', // 上传 / 编辑插件
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/PluginForm'], resolve)
          }
        ]
      },
      {
        path: 'developerPluginVersion', // 插件版本管理
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/PluginVersion'], resolve)
          }
        ]
      },
      {
        path: 'developerPluginOrders', // 我的插件订单
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/PluginOrders'], resolve)
          }
        ]
      },
      {
        path: 'developerIncome', // 我的收益
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/DevIncome'], resolve)
          }
        ]
      },
      {
        path: 'developerBankAccount', // 收款账户
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/BankAccount'], resolve)
          }
        ]
      },
      {
        path: 'developerWithdraw', // 提现
        component: PersonalCenterLayout,
        children: [
          {
            path: '/',
            component: (resolve) => require(['@/views/DeveloperCenter/Withdraw'], resolve)
          }
        ]
      }
    ]
  }

]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
